import React from 'react';
import {connect} from 'react-redux';
import { List, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import L from 'leaflet';
import {fetchResponses} from 'modules/surveys';

class ListResponses extends React.Component {
    componentDidMount() {
        this.props.fetchResponses();
    }

    filterResponses(props) {
        return props.surveys.filter(response => {
            if (props.showMyResponses) {
                if (response.owner_id === props.owner) {
                    return true
                }
            } else {
                return true
            }
        }).sort((a, b) => {
            const sortBy = props.sortBy
            if (sortBy === "create_date") {
                const [aYear, aMonth, aDay] = a.create_date.split("-")
                const [bYear, bMonth, bDay] = b.create_date.split("-")
                return bYear - aYear || bMonth - aMonth || bDay - aDay || 1
            } else {
                if (isNaN(parseFloat(a.field_data[sortBy]))) {
                    return a.field_data[sortBy].localeCompare(b.field_data[sortBy])
                } else {
                    return parseFloat(a.field_data[sortBy]) - parseFloat(b.field_data[sortBy])
                }
            }
        }).filter(response => {
            let passesFilter = true
            if (props.searchFor.length) {
                passesFilter = props.searchFor.split(",").every(searchTerm => {
                    return Object.values(response.field_data).some(value => {
                        return value.toString().toLowerCase().includes(searchTerm.toLowerCase())
                    })
                })
            }
            return passesFilter
        })
    }

    componentWillUnmount() {
        this.props.map.markerLayer.clearLayers();
    }

    render() {
        if (this.props.surveys.length > 0) {
            const responses = this.filterResponses(this.props)
            this.props.map.markerLayer.clearLayers();
            responses.forEach(response => {
                const [lon, lat] = response.center_point.coordinates
                const marker = L.marker([lat, lon])
                marker.bindPopup(`<p>${response.field_data.project_title}</p>`)
                    .on("click", () => this.props.onSelect(response))
                    .on("mouseover", () => marker.openPopup()).on("mouseout", () => marker.closePopup())
                this.props.map.markerLayer.addLayer(marker)
            });

            return (
                <List selection className="response-lists">
                    {responses.map(response => {
                        return (
                            <List.Item key={response.id} onClick={() => this.props.onSelect(response)}>
                                <div className="text-gray response-list-item">
                                    <List.Header as="h4">
                                        {response.field_data.project_title}
                                    </List.Header>
                                    <div className="container-space-between">
                                        <i>{response.field_data.project_type ? response.field_data.project_type.join(", ") : null}</i>
                                        <i>{response.field_data.current_stage}</i>
                                    </div>
                                    <div className="container-space-between">
                                        <i>{response.field_data.project_size} {gettext('acres')}</i>
                                        <i>{response.field_data.timeframe}</i>
                                    </div>
                                    <div style={{marginTop: '.6em'}}>
                                        <b>Lead
                                            Organization:</b> {response.field_data['project_implementation:lead_organizations']
                                    }
                                    </div>
                                </div>
                            </List.Item>
                        )
                    })}
                </List>
            )
        } else {
            return (
                <List selection className="response-lists">
                    <b style={{marginLeft: "1em"}}>No conservation actions available</b>
                </List>
            )
        }
    }
}

ListResponses.propTypes = {
    map: PropTypes.instanceOf(L.Map),
    fetchResponses: PropTypes.func.isRequired,
    surveys: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    onSelect: PropTypes.func.isRequired
}


const mapStateToProps = state => ({surveys: state.getIn(['surveys', 'list']).toJS()});

export default connect(mapStateToProps, {fetchResponses})(ListResponses);



// WEBPACK FOOTER //
// ./source/containers/Surveys/Sidebar/List.jsx